import React from "react";

const ProtheusIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.48984 4.23748C1.50338 7.76352 1.50339 16.6265 7.48984 20.1525C13.4763 23.6785 21 19.247 21 12.195C21 5.14292 13.4763 0.711454 7.48984 4.23748ZM18.3015 15.1313C18.2689 15.8319 17.9051 15.8781 14.9127 15.058C14.9788 16.3459 14.8619 17.7643 14.5388 18.3422C12.2149 18.0929 6.95154 16.8344 5.78629 16.0012C5.45759 13.3179 5.37196 10.8506 5.73362 8.78095C5.95798 8.28599 8.37179 8.97149 9.09016 9.25179C9.01911 7.98459 8.99434 6.29969 9.39507 5.85829C11.5962 6.17552 16.3917 7.51467 17.2335 7.75905C17.7875 7.91991 18.3135 7.93867 18.3785 9.25814C18.5129 11.9877 18.3341 14.4308 18.3015 15.1313ZM14.7335 11.3434C14.8083 11.9916 14.9127 15.058 14.9127 15.058L9.90912 13.683C9.50701 13.5521 9.224 13.191 9.19295 12.7692L9.09016 9.25179C9.09023 9.25181 10.4057 9.50854 11.8394 9.85887C14.4675 10.5011 14.6846 10.9198 14.7335 11.3434Z"
        fill="black"
      />
    </svg>
  );
};

export default ProtheusIcon;
